import KAddressField from "./KAddressField";
import KSelect from "./KSelect";
import KTextField from "./KTextField";
import states from "@/data/states";
import { Geocodable } from "kinnect-mixins";
import {
	VCard,
	VCardText,
	VDivider,
	VToolbar
} from "vuetify/lib";

export default {
	name: "KAddressFormBox",

	mixins: [ Geocodable ],

	props: {
		address: String,
		addressLabel: {
			default: "Address",
			type: String
		},
		city: String,
		cityLabel: {
			default: "City",
			type: String
		},
		lat: [ Number, String ],
		lng: [ Number, String ],
		readonly: Boolean,
		required: Boolean,
		state: String,
		stateLabel: {
			default: "State",
			type: String
		},
		validationScope: String,
		zip: [ Number, String ],
		zipLabel: {
			default: "Zip Code",
			type: String
		}
	},

	render() {
		return <VCard outlined>
			{!this.readonly && [
				<VToolbar flat>
					<KAddressField
						address={this.address}
						city={this.city}
						on={{ ...this.$listeners }}
						state={this.state}
						zip={this.zip}
					></KAddressField>
				</VToolbar>,
				<VDivider></VDivider>
			]}

			<VCardText class="pb-0">
				<KTextField
					dense
					label={`${this.addressLabel}${this.required ? "*" : ""}`}
					outlined
					readonly
					required={this.required}
					size="24"
					tabindex="-1"
					validationName="address"
					validationRules={{ required: this.required }}
					value={this.address}
				></KTextField>

				<KTextField
					dense
					label={`${this.cityLabel}${this.required ? "*" : ""}`}
					outlined
					readonly
					required={this.required}
					tabindex="-1"
					validationName="city"
					validationRules={{ required: this.required }}
					value={this.city}
				></KTextField>

				<KSelect
					dense
					itemText="name"
					itemValue="name"
					items={states}
					label={`${this.stateLabel}${this.required ? "*" : ""}`}
					outlined
					readonly
					required={this.required}
					tabindex="-1"
					validationName="state"
					validationRules={{ required: this.required }}
					value={this.state}
				></KSelect>

				<KTextField
					dense
					label={`${this.zipLabel}${this.required ? "*" : ""}`}
					outlined
					readonly
					required={this.required}
					tabindex="-1"
					validationName="zip"
					validationRules={{ required: this.required }}
					value={this.zip}
				></KTextField>
			</VCardText>
		</VCard>;
	}
};
